import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import qs from 'qs';

export const educationAssetService = {
  getList,
  getAll,
  getById,
  storeOrUpdate,
  destroy,
  getMyTrainings,
};

/**
 * Get paginated list of education assets
 */
function getList(propertyId, params = {}) {
  const queryString = qs.stringify({ property_id: propertyId, ...params }, { addQueryPrefix: true });
  return axios
    .get(
      `${apiEndpoint.educationAssets}${queryString}`,
      {
        headers: authHeader(),
      }
    ).then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

/**
 * Get all education assets (without pagination) for dropdowns
 */
function getAll(propertyId, type = null) {
  const params = { property_id: propertyId };
  if (type) {
    params.type = type;
  }
  const queryString = qs.stringify(params, { addQueryPrefix: true });
  return axios
    .get(
      `${apiEndpoint.educationAssets}/get-all${queryString}`,
      {
        headers: authHeader(),
      }
    ).then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

/**
 * Get single education asset by ID
 */
function getById(id) {
  return axios
    .get(
      `${apiEndpoint.educationAssets}/view?id=${id}`,
      {
        headers: authHeader(),
      }
    ).then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

/**
 * Create or update an education asset
 */
function storeOrUpdate(data, id = null) {
  return (id ? (
    axios
      .post(
        `${apiEndpoint.educationAssets}/update`,
        { ...data, id },
        {
          headers: authHeader(),
        }
      )
  ) : (
    axios
      .post(
        `${apiEndpoint.educationAssets}/create`,
        data,
        {
          headers: authHeader()
        }
      )
  )).then(res => {
    if (res && res.status === 200) {
      return res.data;
    }
    return {};
  });
}

/**
 * Delete an education asset
 */
function destroy(id) {
  return axios
    .post(
      `${apiEndpoint.educationAssets}/delete`,
      { id },
      {
        headers: authHeader()
      }
    ).then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

/**
 * Get education assets where current user is a trainer
 * Returns education assets with facility_id for creating training activities
 */
function getMyTrainings(propertyId = null) {
  const params = {};
  if (propertyId) {
    params.property_id = propertyId;
  }
  const queryString = qs.stringify(params, { addQueryPrefix: true });
  return axios
    .get(`${apiEndpoint.educationAssets}/my-trainings${queryString}`, {
      headers: authHeader(),
    })
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return null;
    });
}
